import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Sparkles, Heart } from "lucide-react";
import { useTranslation } from "react-i18next";

interface GuestPostSessionProps {
  suggestedUsername?: string;
}

const GuestPostSession = ({ suggestedUsername }: GuestPostSessionProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleSignUp = () => {
    navigate("/", { state: { suggestedUsername } });
  };


  const handleDismiss = () => {
    navigate("/");
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="fixed inset-0 z-50 bg-background flex items-center justify-center px-4"
    >
      <div className="absolute inset-0 pointer-events-none">
        <div
          className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[400px] rounded-full opacity-20"
          style={{ background: "radial-gradient(ellipse, hsl(231 99% 62% / 0.4), transparent 70%)" }}
        />
      </div>

      <motion.div
        initial={{ scale: 0.9, y: 20 }}
        animate={{ scale: 1, y: 0 }}
        transition={{ delay: 0.1, type: "spring", stiffness: 200 }}
        className="relative z-10 w-full max-w-sm space-y-6 text-center"
      >
        <motion.div
          initial={{ scale: 0.5, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ delay: 0.2, type: "spring", stiffness: 200 }}
          className="w-16 h-16 rounded-2xl bg-gradient-iris shadow-iris mx-auto flex items-center justify-center"
        >
          <Heart className="w-8 h-8 text-primary-foreground" />
        </motion.div>

        <div className="space-y-2">
          <h2 className="font-display text-2xl font-bold text-foreground">
            {t("guestPost.enjoyThat")}
          </h2>
          <p className="text-sm text-muted-foreground leading-relaxed max-w-[280px] mx-auto">
            {t("guestPost.createDesc")}
          </p>
        </div>

        <div className="space-y-3">
          <button
            onClick={handleSignUp}
            className="w-full py-3.5 rounded-xl bg-gradient-iris text-primary-foreground font-display font-semibold text-base shadow-iris active:scale-95 transition-transform flex items-center justify-center gap-2"
          >
            <Sparkles className="w-4 h-4" /> {t("guestPost.createAccount")}
          </button>


          <button
            onClick={handleDismiss}
            className="w-full py-2.5 text-xs text-muted-foreground hover:text-foreground transition-colors"
          >
            {t("guestPost.maybeLater")}
          </button>
        </div>

        <div className="flex items-center justify-center gap-2 pt-2">
          <span className="font-display text-sm font-semibold text-foreground">ayeris</span>
        </div>
      </motion.div>
    </motion.div>
  );
};

export default GuestPostSession;
